// extracted by css-extract-rspack-plugin
export default {"spin":"src-wab-client-components-widgets-PublishSpinner-module__spin-_PpxIL"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"spin\":\"src-wab-client-components-widgets-PublishSpinner-module__spin-_PpxIL\"}";
        // 1793541991361
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  